import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const NotificationsService = Services.notifications;
const NotificationsTypes = VuexTypes.notifications;
export default {
  [NotificationsTypes.NOTIFICATIONS]: ({ commit, state }, page = 1) => {
    state.notifications['status'] = statuses.LOADING;
    NotificationsService.list(page).then((data) => {
      commit(NotificationsTypes.NOTIFICATIONS, data);
    }).catch((errResponse) => {
      commit(NotificationsTypes.NOTIFICATIONS, errResponse);
    });
  },
  [NotificationsTypes.NOTIFICATIONS_NEW]: ({ commit, state }) => {
    state.notificationsNew['status'] = statuses.LOADING;
    NotificationsService.newNotificationsList().then((data) => {
      commit(NotificationsTypes.NOTIFICATIONS_NEW, data);
    }).catch((errResponse) => {
      commit(NotificationsTypes.NOTIFICATIONS_NEW, errResponse);
    });
  },
  [NotificationsTypes.NOTIFICATION_READ_UPDATE]: ({ commit, state }, { type, ids }) => {
    state.notificationsReadUpdate['status'] = statuses.LOADING;
    const updateType = type === 0 ? 'unread' : 'read';
    NotificationsService.notificationsReadUpdate(updateType, ids).then((data) => {
      commit(NotificationsTypes.NOTIFICATION_READ_UPDATE, data);
    }).catch((errResponse) => {
      commit(NotificationsTypes.NOTIFICATION_READ_UPDATE, errResponse);
    });
  },
};
